"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _ = require("../");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var BlockLink = ( /*#__PURE__*/0, _styledBase["default"])(_.Link, {
  target: "e1xxrsq50",
  label: "BlockLink"
})(process.env.NODE_ENV === "production" ? {
  name: "9tzrgd",
  styles: "display:block;color:inherit;text-decoration:none;"
} : {
  name: "9tzrgd",
  styles: "display:block;color:inherit;text-decoration:none;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0Jsb2NrTGluay9CbG9ja0xpbmsuanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUc4QiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9CbG9ja0xpbmsvQmxvY2tMaW5rLmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IExpbmsgfSBmcm9tICcuLi8nO1xuXG5jb25zdCBCbG9ja0xpbmsgPSBzdHlsZWQoTGluaylgXG4gIGRpc3BsYXk6IGJsb2NrO1xuICBjb2xvcjogaW5oZXJpdDtcbiAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xuYDtcblxuZXhwb3J0IGRlZmF1bHQgQmxvY2tMaW5rO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var _default = BlockLink;
exports["default"] = _default;